import { useEffect } from "react";

import { AmplitudeFlagKey } from "@simplyk/common";
import { useRouter } from "next/router";

import { AmplitudeEvents } from "@/constants/amplitude";
import { useIsUnsupportedBrowserForForms } from "@/features/UnsupportedBrowser/useIsUnsupportedBrowser";
import { getFromLocalStorage } from "@/helpers/localStorage";
import { useAmplitude } from "@/hooks/amplitude/useAmplitude";
import { useAmplitudeFeatureFlag } from "@/hooks/amplitude/useAmplitudeFeatureFlag";

export const RedirectOnUnsupportedFormsBrowser = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { logAmplitudeEvent } = useAmplitude();

  const { isActive: isRedirectionEnabled } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.FormsUnsupportedBrowserRedirection,
  });
  const bypassed = getFromLocalStorage?.("bypassFormsUnsupportedBrowser");

  const isUnsupportedBrowser = useIsUnsupportedBrowserForForms();

  const shouldRedirect = isRedirectionEnabled && isUnsupportedBrowser && bypassed !== "true";

  useEffect(() => {
    if (shouldRedirect) {
      router.replace(
        `/unsupported-browser?source=forms&returnUrl=${encodeURIComponent(window.location.href)}`,
        undefined,
        { shallow: true }
      );
    }
  }, [router, shouldRedirect]);

  useEffect(() => {
    // Send an event to Amplitude if a user would have been redirected to the unsupported browser page
    if (isUnsupportedBrowser) {
      logAmplitudeEvent(AmplitudeEvents.UnsupportedBrowserRedirection, {
        source: "forms",
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <>{children}</>;
};
